import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import "@/plugins/firebase"

import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';

import "../src/design/app.scss";
import store from '@/state/store';
import App from './App.vue';

import i18n from './i18n';
import VueMoment from 'vue-moment'

import moment from 'moment-timezone'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { CoolSelectPlugin } from 'vue-cool-select';
// paste the line below only if you need "bootstrap" theme
import 'vue-cool-select/dist/themes/bootstrap.css';
import CountryFlag from 'vue-country-flag';
import tinymce from 'vue-tinymce-editor';
import VueSimpleContextMenu from 'vue-simple-context-menu'
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css'
import ToggleButton from 'vue-js-toggle-button'
import { MazPhoneNumberInput } from 'maz-ui'
import VueEllipseProgress from 'vue-ellipse-progress';
import 'core-js/stable'; // only stable feature also is possible with only `core-js`
import 'regenerator-runtime/runtime'; // To ensure that regeneratorRuntime is defined globally

Vue.component('vue-simple-context-menu', VueSimpleContextMenu)
Vue.use(MazPhoneNumberInput);
Vue.use(ToggleButton)
Vue.use(VueEllipseProgress);
Vue.component('tinymce', tinymce)
Vue.component('country-flag', CountryFlag)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy)
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
Vue.use(Toast)
Vue.use(CoolSelectPlugin);
moment.locale(i18n.locale);

Vue.use(VueMoment, { moment, })
window.console.log(Vue.moment().locale())

Vue.filter('truncate', function (text, stop, clamp) {
  return text.slice(0, stop) + (stop < text.length ? clamp || '…' : '')
})

Vue.filter('formatNumber', function (number) {
  return Number(number).toLocaleString();
})

Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAPS_API_KEY,
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

window.console.log("vue "+ Vue.version);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
